// images
import urbanGarden from "../assets/images/urban-garden.png";
import nestHub from "../assets/images/nest-hub.png";
import fitlife from "../assets/images/fitness.png";
import codepreneurs from "../assets/images/codepreneurs.png";
import magnetic from "../assets/images/magnetic.png";
import gallery from "../assets/images/gallery.png";
import dayPlanner from "../assets/images/day-planner.png";
import expenses from "../assets/images/expenses.png";
import recipes from "../assets/images/recipes.png";
import tvShows from "../assets/images/tv-shows.png";
import miniStore from "../assets/images/mini-store.png";
import adventureBlog from "../assets/images/adventure-blog.png";
import bikeStore from "../assets/images/bike-store.png";
import artistsGallery from "../assets/images/artists-gallery.png";
import restaurantApp from "../assets/images/restaurants-app.png";
import cosaStore from "../assets/images/cosa-store.png";

const projects = [
  {
    image: urbanGarden,
    repoLink: "https://urban-garden-restaurant.vercel.app",
  },
  {
    image: nestHub,
    repoLink: "https://nest-hub-eight.vercel.app",
  },
  {
    image: fitlife,
    repoLink: "https://fitlife-fitness.vercel.app",
  },
  {
    image: codepreneurs,
    repoLink: "https://codepreneurs.vercel.app",
  },
  {
    image: magnetic,
    repoLink: "https://scss-project-sooty.vercel.app",
  },
  {
    image: gallery,
    repoLink: "https://gallery-beige-ten.vercel.app",
  },
  {
    image: dayPlanner,
    repoLink: "https://day-planner-six.vercel.app",
  },
  {
    image: expenses,
    repoLink: "https://expenses-cyan-two.vercel.app",
  },
  {
    image: recipes,
    repoLink: "https://recipes-js.vercel.app",
  },
  {
    image: tvShows,
    repoLink: "https://tv-shows-rust.vercel.app",
  },
  {
    image: miniStore,
    repoLink: "https://mini-store-nu-sepia.vercel.app",
  },
  {
    image: adventureBlog,
    repoLink: "https://adventure-blog.vercel.app",
  },
  {
    image: bikeStore,
    repoLink: "https://bike-store-tan.vercel.app",
  },
  {
    image: artistsGallery,
    repoLink: "https://artists-gallery-theta.vercel.app",
  },
  {
    image: restaurantApp,
    repoLink: "https://restaurant-app-pi-seven.vercel.app",
  },
  {
    image: cosaStore,
    repoLink: "https://cosa-store.vercel.app",
  },
];

export default projects;
